// extracted by mini-css-extract-plugin
export var root = "QuickView-module--root--41109";
export var titleContainer = "QuickView-module--titleContainer--97ccc";
export var contentContainer = "QuickView-module--contentContainer--5ed40";
export var productContainer = "QuickView-module--productContainer--e899c";
export var productName = "QuickView-module--productName--d8aac";
export var price = "QuickView-module--price--6d140";
export var productImageContainer = "QuickView-module--productImageContainer--18667";
export var sectionContainer = "QuickView-module--sectionContainer--a8515";